import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { goToNews } from '@/app/routing/events'
import { Glow } from '@/shared/ui/glow'

export const SteamOnNews = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.main
  return (
    <div
      className={classes.root}
      onClick={() => goToNews({ variant: 'steamOn' })}
    >
      <Glow
        background={'#E2DF81'}
        width={100}
        left={24}
        top={4}
        zIndex={2}
        filter="blur(45px)"
      />
      <Glow
        background={'#E2DF81'}
        width={100}
        left={'65%'}
        top={84}
        zIndex={2}
        filter="blur(15px)"
      />
      <div className={classes.joinGiveaway}>{texts.joinGiveaway}</div>
      <div className={classes.imageContainer}>
        <img
          src="/assets/subscriptionRelated/gamedLogo.webp"
          alt=""
          className={classes.logo}
        />
        <img
          src="/assets/backgrounds/connectandwin.webp"
          alt=""
          className={classes.logo}
          style={{ height: '12px', width: '120px' }}
        />
      </div>
      <div className={classes.imageContainer2}>
        <img
          src="/assets/backgrounds/huievent2.webp"
          alt=""
          className={classes.playstationWithPack}
        />
      </div>
    </div>
  )
}
